import { ThgPriceViewModelGen } from "@/services/thg/v1/data-contracts";
import { BackwardsCompatibleDataAccessLayer } from "@/store/backwards-compatible-paginated.store";

export const PriceDataAccessLayer = new (class extends BackwardsCompatibleDataAccessLayer<ThgPriceViewModelGen> {})();
